import React from "react";
import styled from "styled-components";
import { apiStaticUrlGet } from "common/api/api_common";
import { usePageNumFromQuery } from "hooks/hook_util/path_query/usePageNumFromQuery";
import { useUnitFromPathSlug } from "hooks/citajteo/dl_unit/path_query/useUnitFromPathSlug";

export default function UnitScan() {
  const page = usePageNumFromQuery();
  const unit = useUnitFromPathSlug();

  if (unit === null) {
    return <></>;
  }
  let ind = page - 1;
  if (ind >= unit.scans.length) {
    ind = 0;
  }

  const pdfUrl = apiStaticUrlGet(
    "dl-unit/scan/" + unit.fold + "/" + unit.scans[ind]
  );

  return (
    <Div>
      <Embed src={pdfUrl} type="application/pdf" />
    </Div>
  );
}

const Div = styled.div`
  margin-top: 0;
  height: 100%;
  &&& > embed: {
    width: 100%;
    height: 100%;
  }
`;

const Embed = styled.embed`
  width: 100%;
  height: 100%;
`;
